import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { routes } from 'routes/RouterStackComponent'
import { Book, BookRate } from '@astrid/components'
import Congratulations from './Congratulations/Congratulations'

import { asyncUpdateGlobalScore, selectCurrentUser } from 'store/services/User'
import useThunkDispatch from 'hooks/useThunkDispatch'

import { asyncUpdateProgressEntity, rateBook, selectCurrentBook } from 'store/services/Book'
import { BookMode } from 'store/services/Book/Book.types'
import { GACategory, GAEvent, trackEvent } from 'utils/analytics'

interface LocationState {
  book: Book
  bookMode: BookMode
}

interface IProps extends RouteComponentProps<{}, {}, LocationState> {}

const FinishedBook: React.FC<IProps> = ({
  history,
  location: {
    state: { book, bookMode }
  }
}) => {
  if (!book || !bookMode) history.push(routes.home)

  const dispatch = useThunkDispatch()
  const profile = useSelector(selectCurrentUser)?.profile
  const { bookProgress } = useSelector(selectCurrentBook)

  const [starsFlying, setStarsFlying] = useState(false)
  const [displayRate, setDisplayRate] = useState(true)

  if (!bookProgress) history.push(routes.home)

  const _rateBook = useCallback(
    async (rate: BookRate) => {
      if (bookProgress) {
        await dispatch(rateBook(bookProgress._id, rate))
        setDisplayRate(false)
      }
    },
    [bookProgress, dispatch]
  )

  const onDidMount = async () => {
    const shouldUpdateReading = bookMode === BookMode.READ && bookProgress && !bookProgress.isCompleted
    const shouldUpdateListening = bookMode === BookMode.LISTEN && bookProgress && !bookProgress.isCompletedListening

    if (shouldUpdateReading || shouldUpdateListening) {
      trackEvent({
        event: GAEvent.BOOK_FINISHED,
        category: GACategory.BOOK,
        label: 'Book finished',
        book_title: book.title
      })

      await dispatch(
        asyncUpdateProgressEntity({
          index: 0,
          bookMode,
          isCompleted: true,
          progressId: bookProgress?._id ?? '0'
        })
      )

      setTimeout(() => {
        setStarsFlying(true)
        dispatch(asyncUpdateGlobalScore(book.totalPoints))
      }, 2000)
    }
  }

  useEffect(() => {
    onDidMount()
    // eslint-disable-next-line
  }, [])

  return (
    <Congratulations
      name={profile!.firstName}
      bookTitle={book.title}
      bookTotalPoints={book.totalPoints}
      globalScore={profile!.globalScore!}
      bookMode={bookMode}
      starsFlying={starsFlying}
      displayRate={displayRate}
      rateBook={_rateBook}
    />
  )
}

export default withRouter(FinishedBook)
